import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { Subject } from 'rxjs';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import { VIEW_NAME } from '../../constants/login-constant';
import { ResetPasswordFormValues } from '../../models/aem';
import {
  ResetPasswordUserResponse,
  error
} from '../../models/reset-password-api.interface';
import { RESET_PASSWORD_ERROR_118 } from './constants/reset-password-facade.constant';
import { ResetPasswordSupportHelperFacadeService } from './reset-password-support-helper.facade.service';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordSupportExtendedFacade extends ResetPasswordSupportHelperFacadeService {
  unsubscribe: Subject<void> = new Subject<void>();
  authConfig = {} as OauthAEMConfig;
  apiResponse = {} as ResetPasswordUserResponse;

  setResetPasswordFormValues(skipSqaContent = false) {
    const formValues = this.getResetPasswordContent().formGroup.getRawValue();
    const values: ResetPasswordFormValues = {
      skymilesNumber: formValues.userId?.value?.trim(),
      firstName: formValues.firstName?.value?.trim(),
      lastName: formValues.lastName?.value?.trim(),
      skipSqaContent
    };
    this.checkEmailFacadeService.newForgotLoginFlow = false;
    this.checkEmailFacadeService.getCheckEmailPageContent();
    this.checkEmailFacadeService.resetLoginPasswordFormValues$.next(values);
  }

  handleNewResetPasswordError(
    authConfig: OauthAEMConfig,
    response: ResetPasswordUserResponse
  ) {
    const errors = response.errors as error[];
    if (authConfig?.NEW_RESET_PASSWORD_FLOW && this.checkForErrorCode(errors)) {
      this.resetForm();
      if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
        this.wifiPortalService.isSecurityQuestionLocked(true);
        this.wifiPortalService.getRefreshUrlWFP(true);
        return;
      }
      this.awsAccountRecoveryFlow(authConfig, errors[0]?.code);
    } else {
      this.setErrorLog(errors);
      this.handleError(errors);
    }
  }

  setErrorLog(errors: error[]): void {
    const errorId = errors[0]?.code;
    const errorDescription = errors[0]?.description;
    if (errorId === RESET_PASSWORD_ERROR_118) {
      this.loggingService.log(
        `Caught Error with errorCode ${errorId} ${errorDescription}`
      );
    }
  }

  handleSuccess(response: ResetPasswordUserResponse) {
    const { viewName } = this.getResetPasswordContent().pageContent;
    if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
      this.wifiPortalService.getRefreshUrlWFP();
      this.createMyPasswordFacade.resetForm();
      this.redirectToNextView(response);
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.SECURITY_QUESTIONS_ANSWERS_LOADED,
        true
      );
      this.nextDisplayViewService.nextDisplayView(
        VIEW_NAME.SECURITY_QUESTION_ANSWER_SCREEN
      );
      return;
    }

    if (this.checkForRecoveryScreenDisplay(response)) {
      this.recoveryOptionsFacade.setContent(this.aemContent, response);
      this.nextDisplayViewService.nextDisplayView(
        VIEW_NAME.CHOOSE_RECOVERY_OPTIONS_SCREEN
      );
    } else {
      this.redirectToNextView(response);
    }
    if (viewName === VIEW_NAME.CREATE_PASSWORD_SCREEN) {
      this.createMyPasswordFacade.resetForm();
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.SET_PASSWORD_LOADED,
        true
      );
      this.nextDisplayViewService.nextDisplayView(
        VIEW_NAME.SET_PASSWORD_SCREEN
      );
    }
  }
}
